import { render, staticRenderFns } from "./drugPremangeseeDtail.vue?vue&type=template&id=ff146f5a&scoped=true"
import script from "./drugPremangeseeDtail.vue?vue&type=script&lang=js"
export * from "./drugPremangeseeDtail.vue?vue&type=script&lang=js"
import style0 from "./drugPremangeseeDtail.vue?vue&type=style&index=0&id=ff146f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff146f5a",
  null
  
)

export default component.exports